module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "cart-wrap"
  }, [_h('cart-header', {
    attrs: {
      "shop-name": shopName
    }
  }), " ", _h('cart-items', {
    attrs: {
      "dishs-data": dishsData
    },
    on: {
      "add-dishz": addDish,
      "minus-dish": minusDish
    }
  }), " ", _h('cart-pay', {
    attrs: {
      "total-number": totalNum,
      "total-price": totalPri
    }
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-e159c496!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Cart.vue
 ** module id = 80
 ** module chunks = 1
 **/